<template>
  <!-- TODO O TEMPLATE FEITO UTILIZANDO O BOOTSTRAP VUE -->
  <div class="productslist">
    <span id="loading" v-if="this.loading == true">
      <Loading />
    </span>
    <!-- BARRA DE PESQUISA -->
    <h2>Países</h2>
    <b-button variant="success" class="mb-3" v-b-modal.addCountryModal>
      + Adicionar País
    </b-button>
    <br />
    <!-- BARRA DE PESQUISA - PESQUISAR POR ENCOMENDA -->
    <div class="searchbar">
      <b-form-input
        class="float-right"
        align-v="center"
        v-model="filter"
        type="search"
        placeholder="Procurar País"
        label-cols-sm="3"
        label-align-sm="right"
        @input="pageOne()"
      >
        ></b-form-input
      >
    </div>
    <!-- PAGINAÇÃO NA PARTE SUPERIOR DA TABELA -->
    <b-pagination
      v-model="currentPage"
      pills
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
      align="center"
    ></b-pagination>
    <!-- TABELA COM TODOS OS PRODUTOS -->
    <div class="table">
      <b-table
        striped
        hover
        :items="countries"
        :fields="fields"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"
        thead-class="text-white"
        small
      >
        <template #cell(coin)="data">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="data.item.coin"
          />
        </template>
        <template #cell(tracking_ini)="data">
          <input
            type="text"
            class="form-control form-control-sm"
            id="tracking_ini"
            v-model="data.item.tracking_ini"
          />
        </template>
        <template #cell(tracking_final)="data">
          <input
            type="text"
            class="form-control form-control-sm"
            id="tracking_final"
            v-model="data.item.tracking_final"
            :disabled="data.item.tracking_single"
          />
        </template>
        <template #cell(tracking_single)="data">
          <b-form-checkbox
            v-model="data.item.tracking_single"
            name="check-button"
            switch
            size="lg"
          ></b-form-checkbox>
        </template>
        <template #cell(tax_iva)="data">
          <input
            type="number"
            class="form-control form-control-sm"
            id="tracking_final"
            v-model="data.item.tax_iva"
          />
        </template>
        <template #cell(tax_iva_reduced)="data">
          <input
            type="number"
            class="form-control form-control-sm"
            id="tracking_final"
            v-model="data.item.tax_iva_reduced"
          />
        </template>
        <template #cell(button)="data">
          <b-button
            v-b-modal.modal-extern
            id="openModal"
            class="btn btn-info"
            @click="updateBrand(data.item)"
            >🔄</b-button
          >
        </template>
      </b-table>
    </div>
    <!-- PAGINAÇÃO NO INFERIO DA TABELA -->
    <b-pagination
      class="customPagination"
      v-model="currentPage"
      pills
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
      align="center"
    ></b-pagination>
    <b-modal id="addCountryModal" title="Adicionar País" hide-footer>
      <b-form @submit.prevent="addCountry">
        <b-form-group label="Código (ex: PT)" label-for="new_code">
          <b-form-input id="new_code" v-model="newCountry.code" required />
        </b-form-group>

        <b-form-group label="Nome" label-for="new_name">
          <b-form-input id="new_name" v-model="newCountry.name" required />
        </b-form-group>

        <b-form-group label="Moeda (ex: EUR)" label-for="new_coin">
          <b-form-input id="new_coin" v-model="newCountry.coin" required />
        </b-form-group>

        <b-form-group label="Tracking #1" label-for="new_t1">
          <b-form-input id="new_t1" v-model="newCountry.tracking_ini" />
        </b-form-group>

        <b-form-group label="Tracking #2" label-for="new_t2">
          <b-form-input
            id="new_t2"
            v-model="newCountry.tracking_final"
            :disabled="newCountry.tracking_single"
          />
        </b-form-group>

        <b-form-group label="Tracking ID único">
          <b-form-checkbox
            v-model="newCountry.tracking_single"
            switch
            size="lg"
          >
            Tracking Single
          </b-form-checkbox>
        </b-form-group>

        <b-form-group label="IVA" label-for="new_iva">
          <b-form-input
            id="new_iva"
            type="number"
            v-model.number="newCountry.tax_iva"
          />
        </b-form-group>

        <b-form-group label="IVA Reduzido" label-for="new_iva_red">
          <b-form-input
            id="new_iva_red"
            type="number"
            v-model.number="newCountry.tax_iva_reduced"
          />
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="$bvModal.hide('addCountryModal')"
          >
            Cancelar
          </b-button>
          <b-button variant="primary" type="submit" :disabled="loading">
            Guardar
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from '@/components/Loading.vue';
import axios from 'axios';
export default {
  components: {
    Loading,
  },
  data: function () {
    return {
      perPage: 100,
      currentPage: 1,
      filter: null,
      criteria: null,
      countries: [],
      rows: 1,
      fields: [
        {
          key: 'code',
          label: 'Código',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 18px; background-color:rgb(255, 147, 147);vertical-align: middle',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Nome',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 18px; background-color:rgb(255, 147, 147);vertical-align: middle',
          sortable: true,
        },
        {
          key: 'coin',
          label: 'Moeda',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 18px; background-color:rgb(255, 147, 147);vertical-align: middle',
        },
        {
          key: 'tracking_ini',
          label: 'Tracking #1',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 18px; background-color:rgb(255, 147, 147); height:50px; vertical-align: middle',
          sortable: true,
        },
        {
          key: 'tracking_final',
          label: 'Tracking #2',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 18px; background-color:rgb(255, 147, 147); height:50px; vertical-align: middle',
          sortable: true,
        },
        {
          key: 'tracking_single',
          label: 'Tracking ID',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 18px; background-color:rgb(255, 147, 147); height:50px; vertical-align: middle',
          sortable: true,
        },
        {
          key: 'tax_iva',
          label: 'Iva',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 18px; background-color:rgb(255, 147, 147); height:50px; vertical-align: middle',
          sortable: true,
        },
        {
          key: 'tax_iva_reduced',
          label: 'Iva Reduzido',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 18px; background-color:rgb(255, 147, 147); height:50px; vertical-align: middle',
          sortable: true,
        },
        {
          key: 'button',
          label: '',
          tdClass: 'align-middle',
          thStyle:
            'font-size: 18px; background-color:rgb(255, 147, 147); height:50px; vertical-align: middle',
        },
      ],
      newCountry: {
        code: '',
        name: '',
        coin: 'EUR',
        tracking_ini: '',
        tracking_final: '',
        tracking_single: false,
        tax_iva: 0,
        tax_iva_reduced: 0,
      },
    };
  },
  methods: {
    /* FUNÇÃO ASSINCRONA QUE VAI À STORE BUSCAR OS PRODUTOS */
    async getAllCountries_fun() {
      this.loading = true;
      try {
        await this.$store.dispatch('fetchAllCountries');
        this.countries = this.getAllCountries;
        /* VERIFICA QUANTAS LINHAS TERÁ A TABELA */
        this.rows = this.countries.length;
      } catch (err) {
        alert(err);
      } finally {
        this.loading = false;
      }
    },
    async updateBrand(data) {
      try {
        if (data.tracking_single == true) {
          data.tracking_final = null;
        }
        await this.$store.dispatch('updateTrackingCountry', {
          country: data.code,
          coin: data.coin,
          tracking_ini: data.tracking_ini,
          tracking_final: data.tracking_final,
          tracking_single: data.tracking_single,
          tax_iva: data.tax_iva,
          tax_iva_reduced: data.tax_iva_reduced,
        });
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: `Variáveis ${data.code} atualizadas`,
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (err) {
        alert(err);
      }
    },

    async confirmAdd(message) {
      const result = await this.$swal.fire({
        title: 'Adicionar?',
        text: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim!',
        cancelButtonText: 'Cancelar',
      });

      return result.isConfirmed;
    },

    async addCountry() {
      const ok = await this.confirmAdd(
        `Tem a certeza que deseja adicionar o país ${this.newCountry.code}?`
      );
      if (!ok) return;

      this.loading = true;

      try {
        if (this.newCountry.tracking_single === true) {
          this.newCountry.tracking_final = null;
        }

        await axios.post(`${this.$store.state.apiUrl}admin/tracking`, {
          code: this.newCountry.code,
          name: this.newCountry.name,
          coin: this.newCountry.coin,
          tracking_ini: this.newCountry.tracking_ini,
          tracking_final: this.newCountry.tracking_final,
          tracking_single: this.newCountry.tracking_single,
          tax_iva: this.newCountry.tax_iva,
          tax_iva_reduced: this.newCountry.tax_iva_reduced,
        });

        this.$swal.fire({
          toast: true,
          icon: 'success',
          title: `País ${this.newCountry.code} criado`,
          timer: 2000,
          position: 'top-end',
        });

        this.$bvModal.hide('addCountryModal');

        // reload list
        await this.getAllCountries_fun();

        // reset form
        this.newCountry = {
          code: '',
          name: '',
          coin: 'EUR',
          tracking_ini: '',
          tracking_final: '',
          tracking_single: false,
          tax_iva: 0,
          tax_iva_reduced: 0,
        };
      } catch (error) {
        console.error('Error adding country:', error);
        this.$swal.fire({
          icon: 'error',
          title: 'Erro ao adicionar país',
          text: 'Por favor, tenta novamente mais tarde.',
        });
      }

      this.loading = false;
    },

    /* FILTRO PARA A BARRA DE PESQUISA */
    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
    },
    pageOne() {
      this.currentPage = 1;
    },
  },
  computed: {
    ...mapGetters(['getAllCountries']),
  },
  async created() {
    /* NA CRIAÇÃO DA PÁGINA CHAMA A FUNÇÃO QUE RETORNA TODOS OS PRODUTOS */
    await this.getAllCountries_fun();
  },
};
</script>

<style scoped>
.productslist {
  text-align: center;
}
.table {
  font-size: 12px;
  margin-top: 30px;
}

/* PONTOS ONDE SURGE A COR DO STOCK */
.dot-yellow {
  height: 20px;
  width: 20px;
  background-color: goldenrod;
  border-radius: 50%;
  display: inline-block;
}
.dot-red {
  height: 20px;
  width: 20px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
}
.dot-green {
  height: 20px;
  width: 20px;
  background-color: green;
  border-radius: 50%;
  display: inline-block;
}

/* BARRA DE PESQUISA */
#filter {
  width: 200px;
  margin-right: 0;
}
.searchbar {
  position: absolute;
  right: 0px;
  width: 200px;
  margin: 10px 20px 0px 0px;
}

.customPage {
  background-color: tomato;
}

h2 {
  margin-top: 20px;
}
</style>
